import React from "react";

import st from "./bottomserver.module.css";

import {
  BsFillCameraFill,
  BsFillFileEarmarkFill,
  BsFillEmojiSunglassesFill,
} from "react-icons/bs";
import { GoGift } from "react-icons/go";

const BottomServer = () => {
  return (
    <section className={st.bottom_server_section}>
      <div className={st.bottom_container}>
        <button>+</button>
        <input type="text" />
        <div className={st.bottom_icons}>
          <button>
            <GoGift />
          </button>
          <button>
            <BsFillCameraFill />
          </button>
          <button>
            <BsFillFileEarmarkFill />
          </button>
          <button>
            <BsFillEmojiSunglassesFill />
          </button>
        </div>
      </div>
    </section>
  );
};

export default BottomServer;
